import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-tittle" }
const _hoisted_2 = { class: "d-flex justify-content-around" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "COMPANY-NAME", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "PHONE-NUMBER", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "EMAIL", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { class: "d-flex justify-content-center" }
const _hoisted_13 = { class: "mlo-tables d-flex flex-column px-4 mt-4" }
const _hoisted_14 = { class: "d-flex justify-content-between pb-4 px-4 gap-5 bg-white rounded-4" }
const _hoisted_15 = { class: "pb-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "mlo-tables__contenido-15year__tittle text-center mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold tw-text-[#00a0da]" }, "Title Company Fees and Services Payments")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_18 = { class: "table-mlo w-100 bg-white p-3 rounded-4" }
const _hoisted_19 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", null, "BUYER", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", null, "%", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, "SELLER", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", null, "%", -1)
const _hoisted_24 = { class: "mlo-tables d-flex flex-column px-4 mt-4" }
const _hoisted_25 = { class: "d-flex justify-content-between pb-4 px-4 gap-5 bg-white rounded-4" }
const _hoisted_26 = { class: "pb-3 w-100" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "mlo-tables_contenido-15year_tittle text-center mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold tw-text-[#00a0da] fs-4" }, "Other Services Prices")
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_29 = { class: "table-mlo w-100 bg-white p-3 rounded-4" }
const _hoisted_30 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = ["onUpdate:modelValue"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", null, "$", -1)
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash" }, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-floppy-o",
  "aria-hidden": "true"
}, null, -1)

import axios from "axios";
  import { ref, toRefs, onMounted } from 'vue';
  import { useToast } from "@/composables/useToast";
  import { environment } from "@/environment";
  //VARIABLES
  
export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyTitleForm',
  props: {
    userID: {
      type: Number,
      default: null,
    },
    addFunction: Function,
    removeFunction: Function,
  },
  setup(__props) {

const props = __props;

  const toast = useToast();
  
  const url = environment.URL_API;
  const loading = ref(false);
  const isSaving = ref(false);
  
  
  const { userID, addFunction, removeFunction } = toRefs(props);
  
  const titleCompanyData = ref({
  ID: null,
  user_id: userID.value,
  name: '',
  phone: '',
  email: '',
  buyer: 0,
  seller: 0,
});

  const otherItems = ref([
    {
      ID: null,
      item: '',
      cost: 0,
      user_id: userID.value
    }
  ]);
  
  const recentlyDeletedItems = ref([]);
  
  const getData = async () => {
    if (isSaving.value) return; 
  
    loading.value = true;
    try {
      const response = await axios.get(
        `${url}company-title?user_id=${userID.value}`
      );
  
      if (!response.data.error) {

        titleCompanyData.value = response.data.companyTitle
        ? {
          ID: response.data.companyTitle.ID,
          user_id: userID.value,
          name: response.data.companyTitle.name || '',
          phone: response.data.companyTitle.phone || '',
          email: response.data.companyTitle.email || '',
          buyer: response.data.companyTitle.buyer || 0,
          seller: response.data.companyTitle.seller || 0,
        }
        : {
          ID: null,
          user_id: userID.value,
          name: '',
          phone: '',
          email: '',
          buyer: 0,
          seller:0,
        };

        if (response.data.otherItems && response.data.otherItems.length > 0) {
          const newItems = response.data.otherItems.filter(item =>
            !recentlyDeletedItems.value.includes(item.ID)
          );
  
          if (newItems.length > 0) {
            otherItems.value = newItems;
          } else {
            otherItems.value = [{
              ID: null,
              item: '',
              cost: 0,
              user_id: userID.value
            }];
          }
        } else {
          otherItems.value = [{
            ID: null,
            item: '',
            cost: 0,
            user_id: userID.value
          }];
        }
  
        recentlyDeletedItems.value = [];
      }
    } catch (error) {
      await toast.error("Error loading data", {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    } finally {
      loading.value = false;
    }
  };
  
  const addItem = () => {
    otherItems.value.push({
      ID: null, 
      item: '',
      cost: 0,
      user_id: userID.value
    });
  };
  
  const removeItem = async (index, ID) => {
    loading.value = true;
    if (ID) {
      try {
        const response = await axios({
          url: `${url}other-items`,
          method: "DELETE",
          data: { ID }
        });
  
        if (!response.data.error) {

          recentlyDeletedItems.value.push(ID);
  
          otherItems.value.splice(index, 1);
          if (otherItems.value.length === 0) {
            otherItems.value.push({
              ID: null,
              item: '',
              cost: 0,
              user_id: userID.value
            });
          }
  
          await toast.success("Item deleted successfully", {
            position: "top-end",
            timer: 2000,
            showCloseButton: true,
          });
        } else {
          await toast.error(response.data.message || "Failed to delete item", {
            position: "top-end",
            timer: 3000,
            showCloseButton: true,
          });
        }
      } catch (error) {
        await toast.error("Error deleting item", {
          position: "top-end",
          timer: 3000,
          showCloseButton: true,
        });
      }
    } else {
      otherItems.value.splice(index, 1);
      if (otherItems.value.length === 0) {
        otherItems.value.push({
          ID: null,
          item: '',
          cost: 0,
          user_id: userID.value
        });
      }
    }
  
    loading.value = false;
  };
  
  const saveData = async () => {
    loading.value = true;
    isSaving.value = true;
  
    try {
      const response = await axios({
        url: `${url}company-title`,
        method: "POST",
        data: {
          companyTitle: titleCompanyData.value,
          otherItems: otherItems.value
        }
      });
  
      if (!response.data.error) {
        recentlyDeletedItems.value = [];
  
        await toast.success(response.data.message || "Data saved successfully", {
          position: "top-end",
          timer: 3000,
          showCloseButton: true,
        });
        setTimeout(() => {
        getData();
        // window.location.reload();
      }, 500
      );
      } else {
        await toast.error(response.data.message || "Error saving data", {
          position: "top-end",
          timer: 3000,
          showCloseButton: true,
        });
      }
    } catch (error) {
      await toast.error("An error occurred while saving data", {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    } finally {
      loading.value = false;
      isSaving.value = false;
    }
  };
  
  
  getData();
 
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createTextVNode(),
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((titleCompanyData.value.name) = $event))
            }, null, 512), [
              [_vModelText, titleCompanyData.value.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createTextVNode(),
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((titleCompanyData.value.phone) = $event))
            }, null, 512), [
              [_vModelText, titleCompanyData.value.phone]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createTextVNode(),
            _hoisted_11,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((titleCompanyData.value.email) = $event))
            }, null, 512), [
              [_vModelText, titleCompanyData.value.email]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("table", _hoisted_19, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_20,
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((titleCompanyData.value.buyer) = $event))
                          }, null, 512), [
                            [_vModelText, titleCompanyData.value.buyer]
                          ])
                        ]),
                        _hoisted_21
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_22,
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((titleCompanyData.value.seller) = $event))
                          }, null, 512), [
                            [_vModelText, titleCompanyData.value.seller]
                          ])
                        ]),
                        _hoisted_23
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("table", _hoisted_30, [
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherItems.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((item.item) = $event)
                              }, null, 8, _hoisted_31), [
                                [_vModelText, item.item]
                              ])
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              "onUpdate:modelValue": ($event: any) => ((item.cost) = $event)
                            }, null, 8, _hoisted_32), [
                              [_vModelText, item.cost]
                            ])
                          ]),
                          _hoisted_33,
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              class: "btn btn-danger btn-sm ms-2",
                              onClick: ($event: any) => (removeItem(index, item.ID))
                            }, _hoisted_36, 8, _hoisted_34)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-primary px-5 mt-3",
                    onClick: addItem
                  }, [
                    _createTextVNode(" Add "),
                    _hoisted_37
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", { class: "d-flex justify-content-center" }, [
      _createElementVNode("button", {
        class: "btn btn-primary px-5 mt-3",
        onClick: saveData
      }, [
        _createTextVNode(" Save Data "),
        _hoisted_38
      ])
    ])
  ], 64))
}
}

})